module.exports = __webpack_public_path__ + "img/the-lost-birds.aea16085.jpg";